// GetHelp.tsx
// import React, { useState } from "react";
// import { Button, Form } from "react-bootstrap";


function GetHelpSubmitted() {

  return (
    <div className="transparent-box">
      <h1 style={{marginBottom: "4vh"}}>Form Submitted!</h1>
      
    </div>
  );
}

export default GetHelpSubmitted;
